import React from "react";
import "./NotFound.css";

export default function NotFound() {
  return (
    <div className="NotFound">
      <h3>Sorry, page not found! </h3>
      <p>Go back to <a href="/home">Home</a></p>
    </div>
  );
}